/**
 * Path: packages/frontend/src/core/plugins/vuetifyConfig.ts
 * Task: Configures and exports the Vuetify instance.
 * Refactoring: Explicitly registering all components and directives to prevent rendering failures
 * in case the vite-plugin-vuetify auto-importer fails or is missing.
 */
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';

// Explicitly import all components and directives to guarantee they are available globally
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  // Registering components globally ensures <v-app>, <v-btn> etc. are always recognized
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#00c3cd',
          secondary: '#5CBBF6',
          suggestion: '#7C4DFF', // <--- NEUE SEMANTISCHE FARBE FÜR SUGGESTIONS
          background: '#F4F5F7', // Light grey background for app, sidebar and lists
          surface: '#FFFFFF',    // Bright white background for content and toolbars
          // High contrast HUD: Dark background and white text when the system is in Light Mode
          'hud-background': '#1E252B',
          'hud-border': '#343F4A',
          'hud-text': '#FFFFFF',
          'hud-text-secondary': '#A3B1CC',
          'hud-text-alternative': '#FF6B6B', // Soft warm coral-red for dark HUD contrast
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#00c3cd',
          secondary: '#5CBBF6',
          suggestion: '#B388FF', // <--- NEUE SEMANTISCHE FARBE FÜR SUGGESTIONS (helleres Lila für Dark Mode)
          background: '#121212', // Very dark background for Dark Mode
          surface: '#1E1E1E',    // Slightly lighter surface (cards, forms)
          // High contrast HUD: Light background and dark text when the system is in Dark Mode
          'hud-background': '#FFFFFF',
          'hud-border': '#E0E0E0',
          'hud-text': '#121212',
          'hud-text-secondary': '#5A6A85',
          'hud-text-alternative': '#C0392B', // Deep crimson-red for light HUD contrast
        },
      },
    },
  },
});
